<template>
  <div class='animated fadeIn'>
    <b-row class='justify-center items-center'>
      <b-col cols='12' lg='10'>
        <b-card>
          <b-row>
          <b-col><label for='input-none'></label></b-col>
            <div v-if="authUser && authUser.role !== 'user'" class='ml-auto pr-10 align-middle'>
              <el-button type='warning' icon='el-icon-plus' circle v-on:click='addMember()'></el-button>
            </div>
          </b-row>
          <b-card-body class='pl-0 pr-0'>
            <b-list-group flush>
              <div v-for='ref in chatRefs' :key='ref.key'>
                <b-list-group-item href='#' class='p-1 m-1 rounded' v-on:click='rowSelect(ref)' variant="secondary">
                <div class='d-flex'>
                  <div class='avatar'>
                    <img v-if="ref.icon" :src='ref.icon' style='max-width:40px; height:auto;' alt=''>
                    <i v-else class='fas fa-user-circle fa-3x'></i>
                  </div>
                  <div class='pl-4 m-0'>{{ ref.name }}<div><p class='p-0 m-0'>{{ unreadMessage(ref) }}</p></div>
                  </div>
                  <div v-if="ref.status === 'pending'" class='ml-auto p-2'><el-button size='small' type='danger' round disabled >Pending</el-button></div>
                  <div v-else-if="ref.status === 'requesting'" class='ml-auto p-2'><el-button size='small' type='success' round style='outline:none;' v-on:click.stop='accept(ref)'>Accept</el-button></div>
                  <div v-else class='ml-auto p-2'>
                    <b-badge v-if='unreadNumber(ref) != 0' variant='danger' style='font-size: 12px;'>{{ unreadNumber(ref) }}</b-badge>
                  </div>
                </div>
                </b-list-group-item>
              </div>
            </b-list-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      chatRefs: [],
      unwatch: null,
      unwatch1: null,
      isInit: false
    }
  },
  computed: {
    ...mapGetters({
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      chatRef: 'chatRef/chatRef',
      chatMessage: 'chatMessage/chatMessage',
      chatStatics: 'chatStatics/chats',
      authUser: 'authUser/user'
    })
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
    if (this.unwatch1) {
      this.unwatch1()
      this.unwatch1 = null
    }
  },
  created () {
    this.$nextTick().then(() => {
      this.unwatch = this.$store.watch(state => this.$store.getters['chatRef/chatRef'], value => {
        this.init()
      })
      this.init()
      this.unwatch1 = this.$store.watch(state => this.$store.getters['chatMessage/chatMessage'], value => {
        this.init()
      })
    })
  },
  methods: {
    init () {
      if (this.isInit) {
        return
      }
      var vm = this
      this.isInit = true
      var async = require('async')
      this.chatRefs = []
      this.$nextTick().then(() => {
        vm.onLoadingMaxTimeout(300)
        async.eachSeries(JSON.parse(JSON.stringify(this.chatRef)), function (ref, cb) {
          var iconUrl = null
          var name = null
          var offset = null
          switch (ref.type) {
            case 'service':
              offset = vm.services.findIndex(service => service.key === ref.key)
              if (offset !== -1) {
                iconUrl = vm.services[offset].icon
                name = vm.services[offset].name
                // vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                var payload = {
                  key: ref.key,
                  name: name,
                  icon: iconUrl,
                  status: ref.status,
                  type: ref.type,
                  enable: ref.enable,
                  location: ref.location,
                  updatedAt: ref.updatedAt,
                  createdAt: ref.createdAt
                }
                vm.chatRefs.push(payload)
                cb()
                // })
              } else {
                cb()
              }
              break
            case 'group':
              offset = vm.groups.findIndex(group => group.key === ref.key)
              if (offset !== -1) {
                iconUrl = vm.groups[offset].icon
                name = vm.groups[offset].name
                // vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                payload = {
                  key: ref.key,
                  name: name,
                  icon: iconUrl,
                  status: ref.status,
                  type: ref.type,
                  enable: ref.enable,
                  location: ref.location,
                  updatedAt: ref.updatedAt,
                  createdAt: ref.createdAt
                }
                vm.chatRefs.push(payload)
                cb()
                // })
              } else {
                cb()
              }
              break
            case 'user':
              offset = vm.users.findIndex(user => user.key === ref.key)
              if (offset !== -1) {
                iconUrl = vm.users[offset].icon
                name = vm.users[offset].name
                // vm.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
                payload = {
                  key: ref.key,
                  name: name,
                  icon: iconUrl,
                  status: ref.status,
                  type: ref.type,
                  enable: ref.enable,
                  location: ref.location,
                  updatedAt: ref.updatedAt,
                  createdAt: ref.createdAt
                }
                vm.chatRefs.push(payload)
                cb()
                // })
              } else {
                cb()
              }
              break
          }
        }, function (err) {
          if (err) console.log(err)
          vm.isInit = false
          vm.$nextTick().then(() => {
            vm.offLoadingMaxTimeout()
          })
        })
      })
    },
    addMember () {
      this.$router.push({path: 'chat/member'})
    },
    rowSelect (ref) {
      var vm = this
      if (ref.status !== 'accepting') {
        return
      }
      this.$store.dispatch('chatMessage/subscribe', ref.location).then(() => {
        vm.$store.dispatch('dispatch/setChat', ref).then(() => {
          vm.$router.push({path: 'chat/message'})
        })
      })
    },
    accept (ref) {
      var vm = this
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      var toRef = db.collection('chats_refs').doc(ref.key).collection('refs').doc(vm.user.key)
      toRef.get().then(function (doc) {
        if (doc.exists) {
          const batch = db.batch()
          var to = JSON.parse(JSON.stringify(doc.data()))
          to.status = 'accepting'
          to.enable = true
          to.updatedAt = parseInt(new Date().getTime() / 1000)
          batch.set(toRef, to)

          var fromRef = db.collection('chats_refs').doc(vm.user.key).collection('refs').doc(ref.key)
          var from = {
            location: ref.location,
            status: 'accepting',
            type: ref.type,
            enable: true,
            createdAt: parseInt(new Date().getTime() / 1000),
            updatedAt: ref.updatedAt
          }
          batch.set(fromRef, from)
          batch.commit().then(function () {
          })
        }
      })
    },
    unreadMessage (ref) {
      var text = ''
      for (var i in this.chatStatics) {
        if (this.chatStatics[i].key === ref.location) {
          if (typeof this.chatStatics[i].last !== 'undefined' && this.chatStatics[i].last !== null) {
            if (this.chatStatics[i].last.type === 'text') {
              text = this.chatStatics[i].last.content
            } else if (this.chatStatics[i].last.type === 'photo') {
              text = '📷'
            } else {
              text = '🎥'
            }
          }
        }
      }
      return text
    },
    unreadNumber (ref) {
      var unread = 0
      for (var i in this.chatStatics) {
        if (this.chatStatics[i].key === ref.location) {
          if (ref.type === 'user') {
            if (typeof this.chatStatics[i].unread !== 'undefined') {
              unread = this.chatStatics[i].unread[this.user.key] ? this.chatStatics[i].unread[this.user.key] : 0
            }
          } else {
            if (typeof this.chatStatics[i].unread !== 'undefined') {
              var keys = Object.keys(this.chatStatics[i].unread)
              var u = 0
              if (keys.length !== 0) {
                u = this.chatStatics[i].unread[keys[0]]
              }
              var r = 0
              if (typeof this.chatStatics[i].read !== 'undefined') {
                r = this.chatStatics[i].read[this.user.key] ? this.chatStatics[i].read[this.user.key] : 0
              }
              unread = u - r
            }
          }
        }
      }
      return unread
    },
    selectSession () {
      this.messages.push(new Date())
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Chat.vue